import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		base: 'w-full flex flex-col md:grid md:grid-cols-6 gap-x-2 md:gap-x-4',
		sliderWrapper: 'md:col-span-6 mt-4',
		figure: 'rounded-l overflow-hidden aspect-square md:aspect-[88/48]',
		image: 'h-full object-cover',
		slide: 'max-w-[80vw] md:max-w-[62vw]'
	},
})

export type StylesVariants = VariantProps<typeof styles>
